const shuttleReports = {
  actions: {
    export: 'Export',
  },

  table: {
    headers: {
      tripId: 'Trip Id',
      routingType: 'Routing Type',
      reservationId: 'Reservation Id',
      externalId: 'External ID',
      reservationStatus: 'Reservation Status',
      tripStatus: 'Trip Status',
      date: 'Date',
      dateType: 'Date Type',
      passenger: 'Passenger',
      email: 'Email',
      phone: 'Phone',
      seats: 'Seats',
      supplier: 'Supplier',
      shuttle: 'Shuttle',
      line: 'Line',
      from: 'From',
      to: 'To',
      driver: 'Driver',
      vehicle: 'Vehicle',
      paymentType: 'Payment Type',
      paymentDetails: 'Payment Details',
      profile: 'Profile',
      shuttleArea: 'Zone',
      dropOff: 'Drop Off',
      area: 'Zone',
      direction: 'Direction',
      price: 'Price',
      pickedTime: 'Picked Time',
      droppedTime: 'Dropped Time',
      noshowTime: 'No Show Time',
      shuttleFare: 'Shuttle Fare',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'New',
          onhold: 'On Hold',
          cancelled: 'Cancelled',
          routing: 'Routing',
          routed: 'Routed',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
        },
      },
    },

    filters: {
      reservationStatus: {
        options: {
          new: 'New',
          onhold: 'On Hold',
          cancelled: 'Cancelled',
          routing: 'Routing',
          routed: 'Routed',
          picked: 'Picked',
          dropped: 'Dropped',
          noshow: 'Noshow',
        },
      },
      tripStatus: {
        options: {
          new: 'New',
          inroute: 'In Route',
          sent: 'Sent',
          approved: 'Approved',
          pickingUp: 'Picking Up',
          done: 'Done',
          cancelled: 'Cancelled',
        },
      },
      routingType: {
        options: {
          bus: 'Bus',
          demand: 'Demand',
          dynamic: 'Dynamic',
        },
      },
    },
  },
  tableSummary: {
    title: 'Shuttle Reports',
    headers: {
      trips: 'Trips',
      reservations: 'Reservations',
      passengers: 'Passengers',
      uniquePassengers: 'Unique Passengers',
    },
  },
};

export default shuttleReports;
